module.exports = __webpack_public_path__ + "img/top.2b8e7a6a.png";